import {
  ColumnOptionsBase,
  EntityColumn,
  entityColumn,
  GridRef,
  GroupColumnRef, numberColumn,
  ServerSideColumnOption,
  stringColumn
} from '@softapps/core';
import { Product } from './product';
import { Signal } from '@angular/core';
import { Translation } from '@softline/ui-core';
import { ProductColumnComponent } from './product-column.component';

export interface ClientSideProductColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, Product> {
  rowGroup?: boolean;
}

export interface ServerSideProductColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, Product>, ServerSideColumnOption {
  rowGroup?: boolean;
}

export type ProductColumnOptions<TRow extends object> = ClientSideProductColumnOptions<TRow> | ServerSideProductColumnOptions<TRow>;

export function productColumn<TRow extends object>(ref: GridRef<TRow> | GroupColumnRef<TRow>,
                                                 translator: (key: string) => Signal<Translation>,
                                                 options: ProductColumnOptions<TRow>): EntityColumn<TRow, Product>{
  return entityColumn(ref, {
    ...options,
    format: v => `${v.cartikelnummer} - ${v.artbez1}`,
    sortBy: v => v.cartikelnummer,
    cellRenderer: ProductColumnComponent,
    serverSideSortField: 'cartikelnummer',
  }, entityRef => {
    stringColumn(entityRef, {
      colId: 'number',
      header: translator('Nummer'),
      getValue: v => v.cartikelnummer
    });
    stringColumn(entityRef, {
      colId: 'name',
      header: translator('Bezeichung'),
      getValue: v => v.artbez1
    });
  });
}
